<template>
    <div>
        <md-autocomplete :md-fuzzy-search=true :md-options="getSanitizedLabels" @md-changed="this.debouncedsearch" @md-selected="setCompanies" v-model="from_company">
            <label>Для поиска компании начните набор текста</label>
            <template slot="md-autocomplete-item" slot-scope="{ item, term }">
                <md-highlight-text :md-term="term">{{ item.name }}</md-highlight-text>
            </template>
        </md-autocomplete>
    </div>
</template>

<script>
import HttpClient from '@/api/calls'
import _ from 'lodash'

export default {
  name: 'CompanySearch',
  props: ['shopId'],
  data: function () {
    return {
      from_company: '',
      companyList: []
    }
  },
  methods: {
    setCompanies (item) {
      this.$emit('setCompany', item.id)
    },
    getList () {
      this.debouncedsearch()
    },
    getCompanies (searchTerm) {
      const $this = this
      if (!searchTerm) {
        this.companyList = []
        return false
      }
      const term = searchTerm.toLowerCase()
      HttpClient.httpGet('shop.listAll', this.prepareFilters(term))
        .then(function (response) {
          $this.parseResponse(response)
        })
    },
    prepareFilters (searchTerm) {
      this.changeFilter(searchTerm)
      let params = {}
      params['page'] = 0
      params['filter'] = this.$store.state.filtersShop
      return params
    },
    changeFilter (searchTerm) {
      this.$store.commit('setFilter', { name: 'name', value: searchTerm })
      this.$store.commit('setFilter', { name: 'q', value: searchTerm })
      this.$emit('changeFilter')
    },
    parseResponse (shopData) {
      this.companyList = []
      if (shopData.data && shopData.data.length !== 0) {
        let length = shopData.data.length
        for (let i = 0; i < length; i++) {
          this.companyList.push({
            id: shopData.data[i].id,
            name: shopData.data[i].name
          })
        }
        this.empty = false
      } else {
        this.companyList = []
        this.empty = true
      }
    }
  },
  computed: {
    getSanitizedLabels () {
      return this.companyList.map(label => ({
        'id': label.id,
        'name': label.name,
        'toLowerCase': () => label.name.toLowerCase(),
        'toString': () => label.name
      }))
    }
  },
  watch: {
    getCompanies: function () {
      this.debouncedsearch()
    }
  },
  created () {
    this.debouncedsearch = _.debounce(this.getCompanies, 200)
  }
}
</script>

<style lang="scss">
    .md-menu.md-select {
        display: flex;
        flex: 1;
        max-height: 100px;

        &:not(.md-disabled) {
            .md-input,
            .md-icon {
                cursor: pointer;
                outline: none;
            }
        }
        .md-input {
            flex: 1;
        }

        select,
        .md-input-fake {
            width: 1px;
            height: 1px;
            margin: -1px;
            padding: 0;
            overflow: hidden;
            position: absolute;
            clip: rect(0 0 0 0);
            border: 0;
        }
    }

    .md-menu-content {
        z-index: 111;

        &.md-select-menu {
            width: 100%;

            &.md-menu-content-enter {
                transform: translate3d(0, -8px, 0) scaleY(.3);
            }

            .md-list {
                transition: opacity .3s;
            }

            .md-dense .md-ripple.md-list-item-content {
                font-size: 14px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/forms/CompanySearch.vue